import React, { useEffect, useState } from 'react';
import { getImage } from '../stores/imageStore';
import { formatDuration } from '../utils/timeUtils';

function RecipeCard({ recipe, onClick }) {
  const [imageUrl, setImageUrl] = useState(null);

  const numIngredients = recipe.ingredients.reduce(
    (total, section) => total + section.items.length,
    0
  );

  useEffect(() => {
    const fetchImage = async () => {
      try {
        if (recipe.images?.length > 0) {
          const url = await getImage(recipe.images[0]);
          setImageUrl(url);
        }
      } catch (error) {
        console.error('Error fetching recipe image:', error);
      }
    };

    fetchImage();
  }, [recipe.images])

  return (
    <div
      className='w-full max-w-sm rounded overflow-hidden shadow-lg bg-white'
      onClick={onClick}
    >
      {imageUrl && (
        <img src={imageUrl} alt={recipe.title} className='w-full h-48 object-cover' />
      )}
      <div className='p-4 flex flex-col justify-between h-full'>
        <h2 className='text-xl font-bold font-sans mb-6'>{recipe.title}</h2>
        <div>
          <p className='text-text-light italic text-sm mb-1'>{recipe.source}</p>
          <div className='flex justify-between'>
            <span>{numIngredients} ingredient{numIngredients > 1 && 's'}</span>
            <span className='font-bold'>{formatDuration(recipe.cookTime)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecipeCard;